class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainAside = this.querySelector('aside');
    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight / 10.0}rem`,
      );

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.openMenuDrawer = this.openMenuDrawer.bind(this);
    this.closeMenuDrawer = this.closeMenuDrawer.bind(this);
    this.bindEvent();
  }

  bindEvent() {
    this.addEventListener('transitionend', () => {
      const isOpen = document.location.hash.includes('menu-drawer-open');

      isOpen ? this.openMenuDrawer() : this.closeMenuDrawer();
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeMenuDrawer(event);
  }

  openMenuDrawer() {
    this.mainAside.focus();
    this.setAttribute('aria-expanded', true);
    document.body.classList.add('u-overflow-hidden');
    document.body.style.overflow = 'hidden';
  }

  closeMenuDrawer() {
    document.location.hash = document.location.hash.replace('menu-drawer-open', '');
    this.setAttribute('aria-expanded', false);
    document.body.classList.remove('u-overflow-hidden');
    document.body.style.overflow = 'auto';
  }
}

customElements.define('menu-drawer', MenuDrawer);
